import React from 'react';
import { FaArrowRight } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import ServicesCard from './ServicesCard';
import ServicesCardData from './ServicesCardData';

function ServicesSection() {
  return (
    <section className="services-wrapper section-padding">
      <div className="container">
        <div className="row">
          <div className="col-lg-6 p-2">
            <div className="section-head mt-40">
              <span className="heading-bg">Offers</span>
              <h2 className="section-title">
                Services and solutions
                <span className="heading-dot" />
              </h2>
            </div>
            <p className="body-text padding-right">
              We will help not only to develop a project and build a high-tech
              house. Our many years of experience proves that we are able to
              cope with objects of varying degrees of complexity.
            </p>
            <Link to="/services-details" className="button button-minimal">
              Learn More
              <span className="icon">
                <FaArrowRight />
              </span>
            </Link>
          </div>

          {ServicesCardData.map((item) => (
            <ServicesCard
              key={item.id}
              heading={item.heading}
              text={item.text}
              background={item.background}
            />
          ))}
        </div>
      </div>
    </section>
  );
}

export default ServicesSection;
